import modelYearTypes from 'commons-vehicle/ModelYear/actions/modelYearActionTypes.js';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { LocalStorageService } from '@sm360/widget-commons-general';

import { BEST_PAYMENT } from 'commons-vehicle/PurchaseMethods/constants/purchaseMethods.js';
import * as DataOrigins from 'commons-vehicle/constants/dataOrigins.js';

import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';
import * as QuoteActions from 'commons-vehicle/Quote/actions/quoteActions.js';
import ModelYearAPIService from 'commons-vehicle/ModelYear/services/ModelYearAPIService/ModelYearAPIService.js';
import ModelYearService from 'commons-vehicle/ModelYear/services/ModelYearService/ModelYearService.js';
import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';
import * as PurchaseMethodsActions from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActions.js';
import * as TradeInVehicleActions from 'commons-vehicle/Vehicle/actions/tradeInVehicleActions.js';

export function setModelYear(modelYear) {
    return { type: modelYearTypes.LOAD_MODEL_YEAR_SUCCESS, modelYear };
}

export function loadModelYearSuccess(modelYear) {
    return { type: modelYearTypes.LOAD_MODEL_YEAR_SUCCESS, modelYear };
}

export function setModelYears(modelYear) {
    return { type: modelYearTypes.SET_MODEL_YEARS, modelYear };
}

export function setModelTrims(modelYear) {
    return { type: modelYearTypes.SET_MODEL_TRIMS, modelYear };
}

export function setDrivePowerTrains(modelYear) {
    return { type: modelYearTypes.SET_DRIVE_POWER_TRAINS, modelYear };
}

export function setOptionsPackages(modelYear) {
    return { type: modelYearTypes.SET_OPTIONS_PACKAGES, modelYear };
}

export function loadModelYears(modelYearsParams, tradeInVehicleParams, initialLoad) {
    return (dispatch, getState) => {
        return ModelYearAPIService.loadModelYears(modelYearsParams, tradeInVehicleParams)
            .then((results) => {
                const state = getState();
                const currentPurchaseMethods = state.purchaseMethods;
                const selectedPurchaseMethod = currentPurchaseMethods.getSelectedPurchaseMethod();
                let modelYear =
                    state.modelYear.modelTrims.size > 0
                        ? ModelYearService.resetPaymentsAndPurchaseAmounts(
                              ModelYearService.resetModelYears(state.modelYear, results.years),
                              currentPurchaseMethods
                          )
                        : ModelYearService.resetModelYears(state.modelYear, results.years);

                modelYear = ModelYearService.selectPurchaseMethod(
                    modelYear,
                    initialLoad ? BEST_PAYMENT : selectedPurchaseMethod
                );

                dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(modelYear.getSelectedYearPurchaseMethods()));
                dispatch(setModelYear(modelYear));

                if (results.tradeInVehicle && results.tradeInVehicle.id) {
                    dispatch(TradeInVehicleActions.setTradeInVehicle(results.tradeInVehicle));
                    dispatch(PurchaseMethodsActions.setTradeIn(results.tradeInVehicle.getTradeInAmount()));
                    dispatch(PurchaseMethodsActions.setLien(results.tradeInVehicle.getLienAmount()));
                } else {
                    const defaultPurchaseMethods = new PurchaseMethodsModel();
                    dispatch(PurchaseMethodsActions.setTradeIn(defaultPurchaseMethods.tradeIn));
                    dispatch(PurchaseMethodsActions.setLien(defaultPurchaseMethods.lien));
                }

                const paymentFrequency = LocalStorageService.get('paymentFrequency');
                if (paymentFrequency) {
                    dispatch(
                        PurchaseMethodsActions.selectPaymentFrequency({
                            value: parseInt(paymentFrequency, 10),
                        })
                    );
                }
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function loadModelYearFromQuote(quote, config) {
    return (dispatch) => {
        const { vehicle } = quote;
        const modelYearsParams = {
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            bodyStyleCode: vehicle.bodyStyleCode,
            modelTrimCode: vehicle.modelTrimCode,
            quoteId: quote.id,
            vehicleConditionType: vehicle.vehicleConditionType,
        };
        const tradeInVehicleParams = {
            id: '',
        };
        return ModelYearAPIService.loadModelYear(modelYearsParams, tradeInVehicleParams, config).then((results) => {
            return dispatch(loadModelYearSuccess(results.modelYear));
        });
    };
}

export function loadModelYear(modelYearsParams, tradeInVehicleParams, unfiltered = false) {
    return (dispatch, getState) => {
        return ModelYearAPIService.loadModelYear(modelYearsParams, tradeInVehicleParams, {}, unfiltered)
            .then((results) => {
                const state = getState();
                const currentPurchaseMethods = state.purchaseMethods;
                const selectedPurchaseMethod = currentPurchaseMethods.getSelectedPurchaseMethod();
                let modelYear = state.modelYear.modelYearsAreLoaded()
                    ? ModelYearService.resetPaymentsAndPurchaseAmounts(
                          ModelYearService.resetModelYears(
                              results.modelYear,
                              state.modelYear.years,
                              modelYearsParams.year
                          ),
                          currentPurchaseMethods
                      )
                    : results.modelYear;
                modelYear = ModelYearService.selectPurchaseMethod(modelYear, selectedPurchaseMethod);

                dispatch(setModelYear(modelYear));
                const { cabSizes } = results.modelYear;
                if (cabSizes && cabSizes.length) {
                    modelYear = ModelYearService.setSelectedCabSize(modelYear, cabSizes[0]);
                } else {
                    const { modelTrims } = results.modelYear;
                    if (modelTrims.size > 0) {
                        if (modelYearsParams.modelTrimCode) {
                            const newOptionsPackage = modelYear.optionsPackages
                                .filter(
                                    (optionsPackage) =>
                                        optionsPackage.configuration.modelTrimCode === modelYearsParams.modelTrimCode
                                )
                                .first();
                            const modelTrimSelectionCode = newOptionsPackage
                                ? newOptionsPackage.configuration.modelTrim.selectionCode
                                : '';
                            const newModelTrim = modelTrimSelectionCode
                                ? modelYear.modelTrims
                                      .filter((modelTrim) => modelTrim.selectionCode === modelTrimSelectionCode)
                                      .first()
                                : state.modelYear.modelTrims.first();

                            modelYear = newModelTrim && ModelYearService.setSelectedModelTrim(modelYear, newModelTrim);
                        } else {
                            modelYear = ModelYearService.setSelectedModelTrim(modelYear, modelTrims.first());
                        }
                    }
                }
                const selectedOptionsPackage = modelYear && modelYear.getSelectedOptionsPackage();

                let exteriorColour = null;
                if (selectedOptionsPackage) {
                    dispatch(setModelYear(modelYear));
                    dispatch(
                        PurchaseMethodsActions.loadPurchaseMethodsSuccess(
                            selectedOptionsPackage.configuration.purchaseMethods
                        )
                    );

                    const interiorColour = modelYear.getSelectedOptionsPackageInteriorColour();
                    if (interiorColour) {
                        const interiorColourAmounts = {
                            retail: interiorColour.retail,
                            residualRetail: interiorColour.residualRetail,
                        };
                        dispatch(PurchaseMethodsActions.setInteriorColourAmounts(interiorColourAmounts));
                    }

                    exteriorColour = modelYear.getSelectedOptionsPackageExteriorColour();
                    if (exteriorColour) {
                        const exteriorColourAmounts = {
                            retail: exteriorColour.retail,
                            residualRetail: exteriorColour.residualRetail,
                        };
                        dispatch(PurchaseMethodsActions.setExteriorColourAmounts(exteriorColourAmounts));
                    }
                }

                if (results.tradeInVehicle && results.tradeInVehicle.id) {
                    dispatch(TradeInVehicleActions.setTradeInVehicle(results.tradeInVehicle));
                    dispatch(PurchaseMethodsActions.setTradeIn(results.tradeInVehicle.getTradeInAmount()));
                    dispatch(PurchaseMethodsActions.setLien(results.tradeInVehicle.getLienAmount()));
                }

                const paymentFrequency = LocalStorageService.get('paymentFrequency');
                if (!modelYearsParams.quoteId && paymentFrequency) {
                    dispatch(
                        PurchaseMethodsActions.selectPaymentFrequency({
                            value: parseInt(paymentFrequency, 10),
                        })
                    );
                }
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function validateSelectedOptions(currentModelYear) {
    return (dispatch, getState) => {
        let modelYear = currentModelYear || getState().modelYear;
        const configuration = modelYear ? modelYear.getSelectedOptionsPackageConfiguration() : null;
        if (!configuration) {
            return Promise.reject();
        }

        const { year, make } = modelYear;
        const locale = LocaleService.getLocale();

        return ShowroomService.validateSelectedOptions(
            DataOrigins.OPTIONS_VALIDATION,
            year,
            make,
            configuration,
            locale,
            '',
            null
        ).then(({ configurationToken, items }) => {
            modelYear = ModelYearService.resetConfigurationToken(modelYear, configurationToken);
            modelYear = ModelYearService.resetOptionsAvailability(modelYear, items);
            dispatch(setOptionsPackages(modelYear));
            let newModelYear = ModelYearService.resetResidualizingAmount(modelYear, items);

            newModelYear = ModelYearService.resetOptionsAvailability(newModelYear, items);
            dispatch(setOptionsPackages(newModelYear));
        });
    };
}

function loadOptionsSuccess(options, modelYear) {
    return (dispatch, getState) => {
        let newModelYear = modelYear || getState().modelYear;
        newModelYear = ModelYearService.setAvailableOptions(newModelYear, options);
        const selectedOptionsPackage = modelYear.getSelectedOptionsPackage();

        if (selectedOptionsPackage) {
            dispatch(setOptionsPackages(newModelYear));
            dispatch(
                PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods)
            );
        }
        return newModelYear;
    };
}

export function loadOptions(modelYear) {
    const { year, make } = modelYear;
    const configuration = modelYear.getSelectedOptionsPackageConfiguration();
    return (dispatch) => {
        return ShowroomService.loadModelTrimOptions(year, make, configuration)
            .then((options) => {
                return dispatch(loadOptionsSuccess(options, modelYear));
            })
            .catch((error) => {
                throw error;
            });
    };
}
function updateExteriorColourAmounts(skipOptionsValidation, currentModelYear) {
    return (dispatch, getState) => {
        const modelYear = currentModelYear || getState().modelYear;
        const exteriorColour = modelYear.getSelectedOptionsPackageExteriorColour();

        if (exteriorColour) {
            const exteriorColourAmounts = {
                retail: exteriorColour.retail,
                residualRetail: exteriorColour.residualRetail,
            };
            dispatch(PurchaseMethodsActions.setExteriorColourAmounts(exteriorColourAmounts));
            if (!skipOptionsValidation) {
                dispatch(validateSelectedOptions(modelYear));
            }
        }
    };
}

function updateInteriorColourAmounts(skipOptionsValidation, currentModelYear) {
    return (dispatch, getState) => {
        const modelYear = currentModelYear || getState().modelYear;
        const interiorColour = modelYear.getSelectedOptionsPackageInteriorColour();

        if (interiorColour) {
            const interiorColourAmounts = {
                retail: interiorColour.retail,
                residualRetail: interiorColour.residualRetail,
            };
            dispatch(PurchaseMethodsActions.setInteriorColourAmounts(interiorColourAmounts));
            if (!skipOptionsValidation) {
                dispatch(validateSelectedOptions(modelYear));
            }
        }
    };
}
export function updateSelectedPackageAmounts(selectedOptionsPackage, skipOptionsValidation, currentModelYear) {
    return (dispatch, getState) => {
        const exteriorColour = selectedOptionsPackage.configuration.getSelectedExteriorColour();
        const interiorColour = selectedOptionsPackage.configuration.getSelectedInteriorColour();
        let modelYear = currentModelYear || getState().modelYear;

        if (exteriorColour || interiorColour) {
            if (exteriorColour) {
                modelYear = ModelYearService.setSelectedExteriorColour(modelYear, exteriorColour);
            }
            if (interiorColour) {
                modelYear = ModelYearService.setSelectedInteriorColour(modelYear, interiorColour);
            }
            dispatch({ type: modelYearTypes.LOAD_MODEL_YEAR_SUCCESS, modelYear });
        }

        dispatch(
            PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods)
        );
        dispatch(updateInteriorColourAmounts(true, modelYear));
        dispatch(updateExteriorColourAmounts(skipOptionsValidation, modelYear));
    };
}

export function updateFromQuote(quoteId, bqConfirmation) {
    return (dispatch, getState) => {
        let state = getState();
        if (state.quote && state.quote.id !== quoteId) {
            return Promise.resolve();
        }
        let newModelYear = ModelYearService.resetModelYearFromQuote(state.modelYear, state.quote);
        dispatch(loadModelYearSuccess(newModelYear));
        return dispatch(loadOptions(newModelYear)).then(() => {
            const selectedOptionsPackage = newModelYear.getSelectedOptionsPackage();
            if (selectedOptionsPackage) {
                state = getState();
                newModelYear = ModelYearService.resetModelYearOptionsFromQuote(state.modelYear, state.quote);
                dispatch(loadModelYearSuccess(newModelYear));
                if (bqConfirmation) {
                    dispatch(validateSelectedOptions(newModelYear, true)).then(() => {
                        dispatch(QuoteActions.setQuote(state.quote.set('modified', false)));
                    });
                }
                return dispatch(updateSelectedPackageAmounts(selectedOptionsPackage, true));
            }
            return Promise.resolve();
        });
    };
}

export default {
    setModelYear,
    setModelYears,
    setModelTrims,
    setDrivePowerTrains,
    setOptionsPackages,
    loadModelYears,
    loadModelYear,
    validateSelectedOptions,
    updateFromQuote,
    loadOptions,
    loadModelYearFromQuote,
    updateExteriorColourAmounts,
    updateInteriorColourAmounts,
    updateSelectedPackageAmounts,
};
